export type BreakPointPassType = -1 | 1;

export interface DocumentState {
    bodyClass: string[];
    breakpointPassed?: BreakPointPassType;
    height: number;
    width: number;
}

export const initialState: DocumentState = {
    bodyClass: [],
    height: typeof window !== "undefined" ? window.innerHeight : 0,
    width: typeof window !== "undefined" ? window.innerWidth : 0,
};



// WEBPACK FOOTER //
// ./src/store/DocumentState.ts